"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeparatorTextContainer = exports.LinksContainer = exports.LinkWrapper = exports.HeaderContentContainer = exports.ColumnsContainer = exports.ColumnModalTemplate = exports.Column = exports.BodyTextContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ColumnModalTemplate = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__ColumnModalTemplate",
  componentId: "sc-i7xj3k-0"
})(function () {
  return (0, _styledComponents.css)(["width:100%;"]);
});
exports.ColumnModalTemplate = ColumnModalTemplate;
var HeaderContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__HeaderContentContainer",
  componentId: "sc-i7xj3k-1"
})(function () {
  return (0, _styledComponents.css)(["width:100%;max-width:724px;margin:0 auto;", ""], (0, _coreMixins.spacing)('margin-bottom', 5));
});
exports.HeaderContentContainer = HeaderContentContainer;
var ColumnsContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__ColumnsContainer",
  componentId: "sc-i7xj3k-2"
})(function () {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;", ""], _coreMixins.respondTo.md((0, _styledComponents.css)(["flex-direction:row;"])));
});
exports.ColumnsContainer = ColumnsContainer;
var Column = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__Column",
  componentId: "sc-i7xj3k-3"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-grow:1;flex-shrink:1;", " justify-content:center;width:100%;", ""], (0, _coreMixins.spacing)('margin-bottom', 3), _coreMixins.respondTo.md((0, _styledComponents.css)(["&:first-child{justify-content:flex-end;", " margin-bottom:0;}&:last-child{justify-content:flex-start;margin-right:0;}", " ", ""], (0, _coreMixins.spacing)('margin-right', 3), props.oneColumn && (0, _styledComponents.css)(["&:first-child{justify-content:center;}"]), props.withoutMarginBottom && (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-bottom', 0)))));
});
exports.Column = Column;
var SeparatorTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__SeparatorTextContainer",
  componentId: "sc-i7xj3k-4"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;width:100%;flex-grow:1;", " ", ""], (0, _coreMixins.spacing)('margin-bottom', 3), _coreMixins.respondTo.md((0, _styledComponents.css)(["width:auto;", " margin-bottom:0;", ""], (0, _coreMixins.spacing)('margin-right', 3), props.withoutMarginBottom && (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-bottom', 0)))));
});
exports.SeparatorTextContainer = SeparatorTextContainer;
var BodyTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__BodyTextContainer",
  componentId: "sc-i7xj3k-5"
})(function () {
  return (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-top', 5));
});
exports.BodyTextContainer = BodyTextContainer;
var LinksContainer = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__LinksContainer",
  componentId: "sc-i7xj3k-6"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;", ""], (0, _coreMixins.spacing)('margin-top', 5));
});
exports.LinksContainer = LinksContainer;
var LinkWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ColumnModalTemplatestyle__LinkWrapper",
  componentId: "sc-i7xj3k-7"
})(function () {
  return (0, _styledComponents.css)(["", " &:last-child{margin-right:0;}"], (0, _coreMixins.spacing)('margin-right', 3));
});
exports.LinkWrapper = LinkWrapper;